import { DayOfWeek } from '@wix/ambassador-ai-scheduling-assistant-v1-business-properties/types';
import { validateProps } from '../utils';
import { isValidBase } from './BaseEntity';
export { DayOfWeek };
export const DEFAULT_CONTACT_HOURS = {
  daysOfTheWeek: [DayOfWeek.MONDAY, DayOfWeek.TUESDAY, DayOfWeek.WEDNESDAY, DayOfWeek.THURSDAY, DayOfWeek.FRIDAY],
  startTime: {
    hour: 7,
    minute: 0
  },
  endTime: {
    hour: 20,
    minute: 0
  }
};
export const DEFAULT_WORKING_HOURS = {
  daysOfTheWeek: [DayOfWeek.MONDAY, DayOfWeek.TUESDAY, DayOfWeek.WEDNESDAY, DayOfWeek.THURSDAY, DayOfWeek.FRIDAY],
  startTime: {
    hour: 9,
    minute: 0
  },
  endTime: {
    hour: 18,
    minute: 0
  }
};
export const DEFAULT_BUSINESS_PROPERTIES = {
  themeColors: {
    primary: '#FF7530',
    secondary: '#FFBA60'
  },
  schedulingHours: [],
  contactHours: [DEFAULT_CONTACT_HOURS],
  contextEnrichments: [{
    title: '',
    information: ''
  }],
  schedulingGuidelines: '',
  sendRemindersBeforeScheduledMeetings: true,
  autoRecurringServices: true,
  waitlist: false
};
export const isValidBusinessProperties = properties => {
  const ans = isValidBase(properties) && validateProps(properties, ['themeColors', 'contextEnrichments', 'schedulingHours', 'schedulingGuidelines', 'contactHours', 'sendRemindersBeforeScheduledMeetings', 'autoRecurringServices', 'waitlist']);
  return ans;
};
//# sourceMappingURL=BusinessProperties.js.map